// extracted by mini-css-extract-plugin
module.exports = {"dotted":"Divider_dotted__3jBPD"};